<script lang="ts">
    import { melt, createSeparator } from '@melt-ui/svelte';

    const {
        elements: { root },
    } = createSeparator({
        decorative: true,
        orientation: 'horizontal',
    });
</script>

<div use:melt={$root} class="px-[20px] w-full">
    <div class="px-[20px] h-[1px] w-full bg-gray-500" />
</div>
